export const account = {
    login: {
        loading: 'Wird geladen...',
        title: 'Anmelden',
        incorrectCredentials: 'Benutzername oder Passwort ist falsch.',
        usernameLabel: 'Benutzername oder E-Mail',
        passwordLabel: 'Passwort',
        submitButton: 'Anmelden',
        noAccount: 'Noch kein Konto?',
        createOne: 'Konto erstellen',
    },
    register: {
        title: 'Konto erstellen',
        subtitle: 'Erstellen Sie ein Konto, um Tickets zu kaufen und zu verwalten.',
        passwordMismatch: 'Die Passwörter stimmen nicht überein.',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        registrationFailed: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        firstNameLabel: 'Vorname',
        lastNameLabel: 'Nachname',
        emailLabel: 'E-Mail-Adresse',
        passwordLabel: 'Passwort',
        confirmPasswordLabel: 'Passwort bestätigen',
        submitButton: 'Konto erstellen & fortfahren',
        haveAccount: 'Sie haben bereits ein Konto?',
        signIn: 'Anmelden',
    },
    myTickets: {
        loading: 'Ihre Tickets werden geladen...',
        loadErrorTitle: 'Tickets konnten nicht geladen werden',
        loadErrorBody: 'Bitte versuchen Sie es später erneut.',
        cancelFailed: 'Bestellung konnte nicht storniert werden. Bitte versuchen Sie es erneut.',
        statusConfirmed: 'Bestätigt',
        statusPending: 'Ausstehend',
        statusCancelled: 'Storniert',
        statusRefunded: 'Erstattet',
        refundProcessed: 'Erstattung verarbeitet',
        bookingCancelled: 'Buchung storniert',
        addToCalendarTitle: 'Zum Kalender hinzufügen',
        cancelButton: 'Stornieren',
        title: 'Meine Tickets',
        emptyTitle: 'Noch keine Tickets',
        emptySubtitle: 'Bereit, Ihre nächste Veranstaltung zu finden?',
        browseEvents: 'Veranstaltungen durchsuchen',
        upcoming: 'Bevorstehend',
        pastEvents: 'Vergangene Veranstaltungen',
        cancelBookingHeader: 'Buchung stornieren',
        cancelBookingContent: 'Sind Sie sicher, dass Sie die Bestellung {orderRef} stornieren möchten? Dies kann nicht rückgängig gemacht werden.',
        confirmCancel: 'Ja, Buchung stornieren',
        keepBooking: 'Buchung behalten',
        ticketCountSingular: '{quantity} Ticket',
        ticketCountPlural: '{quantity} Tickets',
    },
    ticketDetail: {
        loading: 'Ticket wird geladen...',
        notFoundTitle: 'Ticket nicht gefunden',
        backToMyTickets: 'Zurück zu Meine Tickets',
        tapToClose: 'Zum Schließen irgendwo tippen',
        myTicketsLink: 'Meine Tickets',
        addToCalendar: 'Zum Kalender hinzufügen',
        transfer: 'Übertragen',
        transferTitle: 'Tickets an jemand anderen übertragen',
        cancelSuccessMessage: 'Ihre Buchung wurde storniert.',
        cancelFailedMessage: 'Stornierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        refundNote: 'Etwaige Erstattungen werden innerhalb von 5–10 Werktagen auf Ihre ursprüngliche Zahlungsmethode zurückerstattet.',
        statusConfirmed: 'Bestätigt',
        statusPending: 'Ausstehend',
        statusCancelled: 'Storniert',
        statusRefunded: 'Erstattet',
        orderReference: 'Bestellreferenz',
        ticketsLabel: 'Tickets',
        ticketCountSingular: '{quantity} Ticket',
        ticketCountPlural: '{quantity} Tickets',
        purchased: 'Gekauft',
        cancelBooking: 'Diese Buchung stornieren',
        refundReturnedNote: 'Erstattung wurde auf Ihre ursprüngliche Zahlungsmethode zurückerstattet.',
        yourTickets: 'Ihre Tickets',
        tapToEnlargeHint: 'Tippen Sie auf einen QR-Code, um ihn zum Scannen am Eingang zu vergrößern.',
        ticketOfTotal: 'Ticket {index} von {total}',
        usedAt: 'Verwendet {date}',
        tapToEnlarge: 'Zum Vergrößern tippen',
        beforeEvent: 'Vor der Veranstaltung',
        eventResources: 'Veranstaltungsunterlagen',
        spreadTheWord: 'Sagen Sie es weiter',
        shareDescription: 'Teilen Sie Ihren persönlichen Link — wir verfolgen, wen Sie mitgebracht haben.',
        linkCopied: 'Link in die Zwischenablage kopiert!',
        shareThisEvent: 'Diese Veranstaltung teilen',
        shareEventButton: 'Veranstaltung teilen',
        shareText: 'Ich gehe zu {eventName}! Hol dir hier deine Tickets:',
        cancelBookingHeader: 'Buchung stornieren',
        cancelBookingConfirmContent: 'Sind Sie sicher, dass Sie diese Buchung stornieren möchten? Dies kann nicht rückgängig gemacht werden.',
        confirmCancel: 'Ja, Buchung stornieren',
        keepBooking: 'Buchung behalten',
    },
    transfer: {
        loading: 'Bestellung wird geladen...',
        orderNotFoundTitle: 'Bestellung nicht gefunden',
        orderNotFoundBody: 'Diese Bestellung existiert nicht oder kann nicht übertragen werden.',
        backToMyTickets: 'Zurück zu Meine Tickets',
        initiatedTitle: 'Übertragung eingeleitet',
        initiatedBody: 'Wir haben einen Übertragungslink an {email} gesendet. Die Person hat 7 Tage Zeit, ihn anzunehmen. Sie behalten die Tickets, bis dies geschieht.',
        backToTicket: 'Zurück zum Ticket',
        title: 'Ticket übertragen',
        orderSummarySingular: 'Bestellung {orderRef} · {quantity} Ticket',
        orderSummaryPlural: 'Bestellung {orderRef} · {quantity} Tickets',
        instructions: 'Geben Sie die E-Mail-Adresse der Person ein, an die Sie Ihre Tickets übertragen möchten. Sie erhält eine E-Mail mit einem Link zur Annahme. Ihre Tickets bleiben gültig, bis dies geschieht.',
        recipientEmailRequired: 'Bitte geben Sie die E-Mail-Adresse des Empfängers ein.',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        emailMismatch: 'Die E-Mail-Adressen stimmen nicht überein.',
        recipientEmailLabel: 'E-Mail-Adresse des Empfängers',
        confirmEmailLabel: 'E-Mail-Adresse bestätigen',
        emailPlaceholder: 'ihre@email.de',
        confirmEmailPlaceholder: 'ihre@email.de erneut',
        sendButton: 'Übertragungslink senden',
        cancelButton: 'Abbrechen',
    },
    acceptTransfer: {
        loading: 'Übertragung wird geladen...',
        notFoundTitle: 'Übertragung nicht gefunden',
        notFoundBody: 'Dieser Übertragungslink ist ungültig oder wurde bereits verwendet.',
        browseEvents: 'Veranstaltungen durchsuchen',
        expiredTitle: 'Übertragungslink abgelaufen',
        expiredBody: 'Dieser Übertragungslink ist abgelaufen. Bitten Sie den Absender, eine neue Übertragung einzuleiten.',
        alreadyAcceptedTitle: 'Bereits angenommen',
        alreadyAcceptedBody: 'Diese Übertragung wurde bereits angenommen.',
        viewMyTickets: 'Meine Tickets anzeigen',
        cancelledTitle: 'Übertragung storniert',
        cancelledBody: 'Diese Übertragung wurde vom Absender storniert.',
        successTitle: 'Tickets übertragen!',
        successBody: 'Die Tickets für {eventName} befinden sich jetzt in Ihrem Konto.',
        viewMyTicketsButton: 'Meine Tickets anzeigen',
        title: 'Ticketübertragung annehmen',
        orderSummarySingular: 'Bestellung {orderRef} · {quantity} Ticket',
        orderSummaryPlural: 'Bestellung {orderRef} · {quantity} Tickets',
        sentTo: 'Gesendet an: {email}',
        wrongAccountTitle: 'Falsches Konto',
        wrongAccountBody: 'Sie sind als {currentEmail} angemeldet, aber diese Übertragung wurde an {recipientEmail} gesendet. Bitte melden Sie sich ab und mit dem richtigen Konto an.',
        acceptInstructions: 'Klicken Sie unten, um diese Tickets anzunehmen und Ihrem Konto hinzuzufügen.',
        acceptButton: 'Übertragung annehmen',
    },
    profile: {
        loading: 'Profil wird geladen...',
        title: 'Mein Profil',
        profileUpdated: 'Profil aktualisiert.',
        profileUpdateFailed: 'Profil konnte nicht aktualisiert werden.',
        avatarUpdated: 'Profilbild aktualisiert.',
        avatarUploadFailed: 'Profilbild konnte nicht hochgeladen werden. Verwenden Sie ein JPG, PNG oder WebP unter 5 MB.',
        passwordChanged: 'Passwort geändert.',
        currentPasswordIncorrect: 'Aktuelles Passwort ist falsch.',
        passwordChangeFailed: 'Passwort konnte nicht geändert werden.',
        newPasswordMismatch: 'Die neuen Passwörter stimmen nicht überein.',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        photoSectionTitle: 'Profilbild',
        uploading: 'Wird hochgeladen…',
        uploadPhoto: 'Foto hochladen',
        photoHint: 'JPG, PNG oder WebP. Wird in Teilnehmerlisten von Veranstaltungen angezeigt.',
        personalDetailsTitle: 'Persönliche Angaben',
        firstNameLabel: 'Vorname',
        lastNameLabel: 'Nachname',
        phoneLabel: 'Telefon',
        phonePlaceholder: '+49 170 1234567',
        bioLabel: 'Über mich',
        bioPlaceholder: 'Erzählen Sie anderen Teilnehmern etwas über sich…',
        socialLinks: 'Soziale Links',
        websiteLabel: 'Webseite',
        websitePlaceholder: 'https://ihrewebseite.de',
        twitterLabel: 'Twitter- / X-Handle',
        twitterPlaceholder: 'ihrhandle (ohne @)',
        linkedinLabel: 'LinkedIn-URL',
        linkedinPlaceholder: 'https://linkedin.com/in/sie',
        privacy: 'Datenschutz',
        showOnAttendeeLists: 'Mich in Teilnehmerlisten von Veranstaltungen anzeigen',
        attendeeListsDescription: 'Wenn aktiviert, erscheinen Ihr Name und Profil auf Veranstaltungsseiten, bei denen der Veranstalter die Teilnehmerliste aktiviert hat. Sie können dies jederzeit ändern.',
        saveChanges: 'Änderungen speichern',
        changePasswordTitle: 'Passwort ändern',
        currentPasswordLabel: 'Aktuelles Passwort',
        newPasswordLabel: 'Neues Passwort',
        confirmNewPasswordLabel: 'Neues Passwort bestätigen',
        changePasswordButton: 'Passwort ändern',
    },
    memberships: {
        loading: 'Mitgliedschaften werden geladen...',
        title: 'Mitgliedschaften',
        hasMemberships: 'Hier sind Ihre aktuellen Mitgliedschaften.',
        noMemberships: 'Sie haben noch keine Mitgliedschaften.',
        loadErrorTitle: 'Mitgliedschaften konnten nicht geladen werden',
        loadError: 'Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
        yourMemberships: 'Ihre Mitgliedschaften',
        colName: 'Name',
        colStartDate: 'Startdatum',
        colEndDate: 'Verlängert / endet',
        colCost: 'Kosten',
        colStatus: 'Status',
        recurring: 'Wiederkehrend',
        free: 'Kostenlos',
        active: 'Aktiv',
        activeUntil: 'Aktiv bis {date}',
        undoCancellation: 'Kündigung rückgängig machen',
        cancelMembership: 'Kündigen',
        availablePlans: 'Verfügbare Pläne',
        creditsPerMonth: '{count} Credits pro Monat',
        creditPerMonth: '{count} Credit pro Monat',
        selectButton: 'Auswählen',
        noPlansAvailable: 'Derzeit sind keine Mitgliedschaftspläne verfügbar.',
        confirmCancelTitle: 'Diese Mitgliedschaft kündigen?',
        confirmCancelFree: 'Möchten Sie diese Mitgliedschaft wirklich kündigen? Dies kann nicht rückgängig gemacht werden.',
        confirmCancelPaid: 'Ihre Mitgliedschaft bleibt bis {date} aktiv und wird danach nicht verlängert. Sie können dies bis dahin jederzeit rückgängig machen.',
        keepButton: 'Mitgliedschaft behalten',
        confirmButton: 'Ja, kündigen',
        cancelButton: 'Abbrechen',
        subscribeTitle: '{name} abonnieren',
        preparingPayment: 'Zahlung wird vorbereitet...',
        paymentError: 'Zahlungsfehler',
        paymentInitError: 'Zahlung konnte nicht eingerichtet werden. Bitte versuchen Sie es erneut.',
        subscriptionActivated: 'Abonnement aktiviert',
        subscriptionSuccess: 'Ihre Mitgliedschaft ist jetzt aktiv.',
        doneButton: 'Fertig',
        subscribeButton: 'Abonnieren',
        paymentFailed: 'Zahlung fehlgeschlagen',
        subscribeFailed: 'Das Abonnement konnte nicht erstellt werden. Bitte überprüfen Sie Ihre Kartendaten und versuchen Sie es erneut.',
        cancelError: 'Mitgliedschaft konnte nicht gekündigt werden. Bitte versuchen Sie es erneut.',
        reactivateError: 'Mitgliedschaft konnte nicht reaktiviert werden. Bitte versuchen Sie es erneut.',
    },
    protectedRoute: {},
};
